export default __webpack_public_path__ + "static/media/thunderstorm.baf92f59.svg";